// import * as Sentry from '@sentry/browser'

let loadedOnPage = false

class GoogleMap {
  static loadGoogleMapsApi(libraries) {
    // const event = {
    //   message: 'Loading Google Maps API',
    //   level: 'info',
    //   tags: {
    //     libraries: libraries,
    //     api: 'google-maps',
    //   },
    // }
    // Sentry.captureEvent(event)
    if (loadedOnPage) {
      return Promise.resolve()
    }
    loadedOnPage = true
    const loadGoogleMapsApi = require('./load-google-maps-api')
    return loadGoogleMapsApi({
      key: process.env.GOOGLE_MAPS_KEY,
      libraries,
      map_ids: '61fc38ed81390df6',
    })
  }
}

export { GoogleMap }
